import * as PropTypes from "prop-types";
import sanitizeHtml from 'sanitize-html';


/**
 *  Used to display the HTML formatted text input into various X2O configuration options using the standard X2O formatted text box - bold, underline and so on...
 *  See the sanitize-html info page for more on the options below
 *  https://www.npmjs.com/package/sanitize-html
 */
const OurHTMLFormattedText = ({ htmlFormattedText, className }) => {

    // Add to defaults to add support for underline (<span style="text-decoration: underline;">)
    const cleanHTML = (htmlText) => {
        const options = {
            allowedAttributes: { ...sanitizeHtml.defaults.allowedAttributes, span: ['style'] },
            parseStyleAttributes: false,
        }
        return sanitizeHtml(htmlText, options);
    }

    // Safe HTML block with optional styling class
    return <div className={className} dangerouslySetInnerHTML={{__html: (htmlFormattedText ? cleanHTML(htmlFormattedText) : '') }}></div>
}

OurHTMLFormattedText.propTypes = {
    htmlFormattedText: PropTypes.string,
    className: PropTypes.string,
};

OurHTMLFormattedText.defaultProps = {
    htmlFormattedText: undefined,
    className: undefined,
}

export default OurHTMLFormattedText;